import Video from 'next-video';

export interface MuxVideoProps {
  src: string;
  posterSrc?: string;
  loop?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
  controls?: boolean;
}
export const MuxVideo = ({
  src,
  posterSrc,
  loop = false,
  autoPlay = false,
  muted = true,
  controls = false,
}: MuxVideoProps) => {
  let autoPlayProp;

  if (autoPlay && muted) {
    autoPlayProp = 'muted';
  } else if (autoPlay && !muted) {
    autoPlayProp = 'any';
  } else {
    autoPlayProp = undefined;
  }

  return (
    <Video
      src={src}
      autoPlay={autoPlayProp}
      muted={muted}
      controls={controls}
      loop={loop}
      poster={posterSrc}
      placeholder="blur"
      blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
      accentColor="#FE5E44"
      className="overflow-clip"
    />
  );
};
